import { React} from 'react';
import Tooltip from "@material-ui/core/Tooltip";
import {withStyles} from '@material-ui/core/';

export const LightTooltip = withStyles((theme) => ({
        tooltip: {
          backgroundColor: theme.palette.common.white,
          color: 'rgba(0, 0, 0, 0.87)',
          boxShadow: theme.shadows[1],
          fontSize: 15,
        },
      }))(Tooltip);
    
